import { preprocess } from '@artica/assets';
import { take } from '@immutabl3/utils';
import {
  Color,
  DoubleSide,
  MeshBasicMaterial,
} from 'three';

preprocess('competition', function preprocessCompetition(fbx) {
  fbx.traverse(function(object) {
    if (!object.material) return;
    object.material = new MeshBasicMaterial({
      side: DoubleSide,
      color: new Color(1, 0, 0),
    });
  });

  fbx.paths = take(fbx.children.filter(({ isLine }) => isLine), 5);

  fbx.cardFgPaths = fbx.getObjectByName('Group_Cards_Comp_FG').children;

  return fbx;
});